export const REMOVE_COMPONENT_ACTION = 'remove';
export const MOVE_COMPONENT_ACTION = 'move';
export const ADD_COMPONENT_ACTION = 'add';
export const GRID_BREAKPOINTS = { lg: 992, sm: 0 };
